import React from 'react'

const DetailsContext = React.createContext({})

export const DetailsProvider = DetailsContext.Provider

export function useDetailsMeta() {
  return React.useContext(DetailsContext)
}

export const withDetailsMeta = (Component) => (props) => {
  const detailsMeta = useDetailsMeta()

  return <Component {...props} detailsMeta={detailsMeta} />
}
